import { Song } from "#app/models/song.ts";
import { LinkTo } from "@ember/routing";
import { pageTitle } from "ember-page-title";

const validSongModel = { song: new Song({}) };

<template>
  {{pageTitle "Home"}}
  <div class="m-6 flex flex-col gap-6">
    <div class="flex items-center gap-4">
      <a href="/tests" class="underline text-blue-500 hover:text-blue-600">Tests</a>
    </div>

    <div>
      <h2 class="text-lg font-bold">Internal links (<code>&lt;LinkTo&gt;</code>)</h2>
      <div>
        <LinkTo @route="play" class="underline text-blue-500 hover:text-blue-600"><code>play</code>
          route</LinkTo>
      </div>
      <div>
        <LinkTo @route="play.index" class="underline text-blue-500 hover:text-blue-600"><code
          >play.index</code>
          route</LinkTo>
      </div>

      <div>
        <LinkTo
          @route="play.song"
          @model={{validSongModel}}
          class="underline text-blue-500 hover:text-blue-600"
        >
          <code>play.song</code>
          route</LinkTo>
        with valid empty song object
      </div>
    </div>

    <div>
      <h2 class="text-lg font-bold">External incoming links (<code>&lt;a&gt;</code> tags)</h2>
      <div>
        <a href="/play" class="underline text-blue-500 hover:text-blue-600">/play</a>
      </div>
      <div>
        <a href="/play/xyz" class="underline text-blue-500 hover:text-blue-600">/play/xyz</a>
        (invalid song data)
      </div>
      <div><a
          href="/play/N4IgdghgtgpiBcICiUAOAXAngAgMoHswBzEAGhHRjXwQEYAGe8gYwAsIwwYAbAZwQDaAXQC%252BQA%253D%253D"
          class="underline text-blue-500 hover:text-blue-600"
        >/play/N4IgdghgtgpiBcICiUAOAXAngAgMoHswBzEAGhHRjXwQEYAGe8gYwAsIwwYAbAZwQDaAXQC%252BQA%253D%253D</a>
        (valid song data)
      </div>
    </div>
  </div>
</template>
